import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-wizard-step',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <g-row style="margin-left: -45px">
            <g-col [width]="35">
                <button type="button" class="button button--icon" (click)="prevStep.emit()">←</button>
            </g-col>
            <g-col [paddingLeft]="0" class="wizard-step-title">
                <small *ngIf="groupTitle" class="info wizard-step-title__title-above">{{groupTitle.toUpperCase()}}</small>
                <h2 style="margin-top: 4px">{{title}}</h2>
            </g-col>
        </g-row>

        <ng-content></ng-content>

        <br>
        <g-row style="margin-left: -45px">
            <g-col [width]="35">
                <button type="button" class="button button--icon" (click)="prevStep.emit()">←</button>
            </g-col>
            <g-col [paddingLeft]="0">
                <ng-content select="[buttons]"></ng-content>
                <button *ngIf="nextButtonName" type="button" class="button-green nowrap" (click)="nextStep.emit()">
                    {{nextButtonName}} →
                </button>
            </g-col>
        </g-row>
    `,
    styles: [`
        .wizard-step-title {
            position: relative;
        }

        .wizard-step-title__title-above {
            position: absolute;
            top: -10px;
            letter-spacing: 1.3px;
            white-space: nowrap;
        }
    `]
})

export class WizardStepComponent implements OnInit {

    @Input() title: string;
    @Input() groupTitle: string;
    @Input() nextButtonName: string;

    @Output() prevStep = new EventEmitter();
    @Output() nextStep = new EventEmitter();


    constructor() {
    }

    ngOnInit() {
    }
}
